import React from "react";
import { CheckCircle2, AlertTriangle, Info, X } from "lucide-react";

const styles = {
  success: {
    wrap: "border-emerald-200 bg-emerald-50",
    icon: "bg-emerald-100 text-emerald-600",
    title: "text-emerald-700",
    text: "text-emerald-700",
    btn: "text-emerald-500 hover:bg-emerald-100",
  },
  error: {
    wrap: "border-rose-200 bg-rose-50",
    icon: "bg-rose-100 text-rose-600",
    title: "text-rose-700",
    text: "text-rose-700",
    btn: "text-rose-500 hover:bg-rose-100",
  },
  info: {
    wrap: "border-[#f2c6cc] bg-[#fff7f8]",
    icon: "bg-[#fdecef] text-[#d86a78]",
    title: "text-[#c75a69]",
    text: "text-[#b85a67]",
    btn: "text-[#d86a78] hover:bg-[#fdecef]",
  },
};

function getIcon(type) {
  if (type === "success") return CheckCircle2;
  if (type === "error") return AlertTriangle;
  return Info;
}

export default function ThemeMessagePopup({
  open,
  type = "info",
  title = "",
  message = "",
  onClose,
}) {
  if (!open) return null;

  const ui = styles[type] || styles.info;
  const Icon = getIcon(type);

  return (
    <div className="fixed right-5 top-5 z-[1200] w-full max-w-[420px] animate-[slideIn_.25s_ease]">
      <div className={`rounded-[18px] border shadow-xl ${ui.wrap}`}>
        <div className="flex items-start gap-3 p-4">
          <div className={`mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${ui.icon}`}>
            <Icon size={20} />
          </div>

          <div className="min-w-0 flex-1">
            <h3 className={`text-[15px] font-bold ${ui.title}`}>{title}</h3>
            <p className={`mt-1 text-[13px] leading-5 ${ui.text}`}>{message}</p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className={`rounded-full p-1.5 transition ${ui.btn}`}
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}